const steps = [
  { icon: 'ri-edit-line', label: '설문 작성' },
  { icon: 'ri-store-2-line', label: '매장 방문' },
  { icon: 'ri-sparkling-2-line', label: '맞춤 케어' },
];

export default function ProgressPreview() {
  return (
    <div
      className="flex items-center justify-center gap-0"
      style={{ animationDelay: '450ms' }}
    >
      {steps.map((s, i) => (
        <div key={s.label} className="flex items-center">
          <div className="flex flex-col items-center gap-1.5">
            <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center">
              <i className={`${s.icon} text-[#C6503C] text-base`} />
            </div>
            <span className="text-[11px] text-[#55575D] whitespace-nowrap">{s.label}</span>
          </div>
          {i < steps.length - 1 && (
            <div className="flex items-center mx-2 pb-4">
              <i className="ri-arrow-right-s-line text-[#E3E0D9] text-lg" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}